import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock-outline",
  "use": "lock-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"lock-outline\"><path fill-rule=\"evenodd\" d=\"M14 15.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2Zm3-7v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2h-1Zm-5-5.1c1.71 0 3.1 1.39 3.1 3.1v2H8.9v-2c0-1.71 1.39-3.1 3.1-3.1ZM6 20.5v-10h12v10H6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol